import { mm } from "@inovitas/infra3dsdk";
import { Box } from "@mui/material";
import { useEffect, useRef } from "react";

import AxisscaleBar from "shared/common/classes/AxisscaleBar";
import { defaultStore } from "shared/common/stores/defaultStore";

export default function AxisScaleBar({
  activeAxis,
}: {
  activeAxis: mm.Axis | null;
}) {
  const viewer = defaultStore((state) => state.viewer);
  const clientConfig = defaultStore((state) => state.clientConfig);

  const containerRef = useRef<HTMLDivElement>(null);
  const axisscaleBarRef = useRef<AxisscaleBar | null>(null);

  useEffect(() => {
    if (
      !containerRef.current ||
      !viewer ||
      !clientConfig ||
      !clientConfig.linref
    )
      return;

    axisscaleBarRef.current = new AxisscaleBar(
      viewer,
      containerRef.current,
      clientConfig.linref
    );

    return () => {
      axisscaleBarRef.current?.destroy();
      axisscaleBarRef.current = null;
    };
  }, [viewer]);

  useEffect(() => {
    if (!viewer) return;
    if (!viewer.getScene().getLRHandler().reloadingAxis) {
      axisscaleBarRef.current?.changeAxis(activeAxis);
    }
  }, [activeAxis]);

  return (
    <Box
      id="infra3d-axisscalebar"
      ref={containerRef}
      sx={{
        width: { xs: "150px", md: "300px", lg: "600px" },
        transition: "width 0.3s",
        height: "40px",
        paddingInlineStart: 1,
        paddingInlineEnd: 2,
      }}
    ></Box>
  );
}
